import getAllRegistersByEventId from './getAllRegistersByEventId';
import getConfigs from './getConfigs';
import getConfigValues from './getConfigValues';
import getGuestsWithClassificationBySchedule from './getGuestsWithClassificationBySchedule';
import getOrganization from './getOrganization';
import getSchedule from './getSchedule';
import getStands from './getStands';
import inactiveStand from './inactiveStand';
import saveConfig from './saveConfig';
import saveStand from './saveStand';

export default {
  getAllRegistersByEventId,
  getConfigs,
  getConfigValues,
  getGuestsWithClassificationBySchedule,
  getOrganization,
  getSchedule,
  getStands,
  inactiveStand,
  saveConfig,
  saveStand,
};
